import { useContextTypeSettingsOrganization } from "../../routes/dashboard/dashboard-layout";

/**
 * Returns whether the approval workflow is enabled for the current org.
 *
 * Reads Organization.approvalEnabled directly from the dashboard outlet context
 * (single source of truth per D-14). The `organizationId` parameter is preserved
 * for call-site back-compat but is intentionally unused — the context already
 * tracks exactly one "selected" organization, and every current caller passes
 * `selectedOrganization?.id`, so there is no risk of mismatch.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useApprovalEnabled = (organizationId: string | undefined): boolean => {
  const { selectedOrganization } = useContextTypeSettingsOrganization();
  return selectedOrganization?.approvalEnabled ?? false;
};
